// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import IssueNotificationsRegistration from './IssueNotificationsRegistration';

Vue.config.productionTip = false;

/* eslint-disable no-new */

var NotificationVue = Vue.extend({
  data() {
    return {
      data: JSON.parse(document.getElementById('issue-notifications-registration').getAttribute('data-issue-notifications-registration')),
      dataRecaptchaInformationText: document.getElementById('issue-notifications-registration').getAttribute('data-issue-notifications-registration-RecaptchaInformationText'),
      cmsDataMainBody: JSON.parse(JSON.stringify(document.getElementById('issue-notifications-registration').getAttribute('data-issue-notifications-registration-mainBody'))),
      cmsDataCreateSubscriptionConfirmationPopupText: JSON.parse(JSON.stringify(document.getElementById('issue-notifications-registration').getAttribute('data-issue-notifications-registration-CreateSubscriptionConfirmationPopupText')))
    };
  }
});

/* eslint-disable no-new */
if (document.getElementById('issue-notifications-registration')) {
  new NotificationVue({
    el: '#issue-notifications-registration',
    template: '<issue-notifications-registration />',
    components: { IssueNotificationsRegistration }
  });
}



// WEBPACK FOOTER //
// ./src/main.js